module.exports = __webpack_public_path__ + "static/img/MV6.a6e4d2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV6.jpg
// module id = 3rxl
// module chunks = 0